export const data = {
  imgObj: {
    alt: '',
    src: 'https://media.product.which.co.uk/prod/images/original/f14d6d37ebe2-tooliconquestionwhite.jpg',
  },
}
